import React, { useEffect, useRef } from "react";
import Chart from "chart.js/auto";
import moment from "moment";
import Loader from "./Loader";
import "./ChartComponent.css"

const ChartComponent = ({
  data,
  currentMonth,
  setCurrentMonth,
  isLoading,
  setIsloading,
}) => {
  const taskChartRef = useRef(null);

  const taskChartInstance = useRef(null);
  const hourChartInstance = useRef(null);

  useEffect(() => {
    if (!data || data.length === 0) return;

    const filtered = data.filter((task) => task.status === "Completed");

    // 👉 Aggregate by date
    const grouped = {};

    filtered.forEach((task) => {
      const dateKey = moment(task.date).format("DD MMM");

      if (!grouped[dateKey]) {
        grouped[dateKey] = {
          taskDeliveryCount: 0,
          taskParcelCount: 0,
          totalDeliveryHours: 0,
          totalParcelHours: 0,
        };
      }

      if (task.workType?.trim() === "Delivery") {
        grouped[dateKey].taskDeliveryCount += 1;
      }

      if (task.workType?.trim() === "Parcel") {
        grouped[dateKey].taskParcelCount += 1;
      }
    });

    const labels = Object.keys(grouped);
    const taskDeliveryCounts = labels.map((d) => grouped[d].taskDeliveryCount);
    const taskParcelCounts = labels.map((d) => grouped[d].taskParcelCount);

    // 🔥 Destroy previous instances
    if (taskChartInstance.current) {
      taskChartInstance.current.destroy();
    }
    if (hourChartInstance.current) {
      hourChartInstance.current.destroy();
    }

    // 📊 Chart 1 – Task Count
    taskChartInstance.current = new Chart(taskChartRef.current, {
      type: "bar",
      data: {
        labels,
        datasets: [
          {
            label: "Delivery",
            data: taskDeliveryCounts,
            backgroundColor: "rgba(54, 162, 235, 0.7)",
          },
          {
            label: "Parcel",
            data: taskParcelCounts,
            backgroundColor: "rgba(255, 159, 64, 0.7)",
          },
        ],
      },
      options: {
        responsive: true,
        plugins: {
          legend: { display: true },
        },
        scales: {
          y: {
            beginAtZero: true,
          },
        },
      },
    });
  }, [data]);

  const handlePrevMonth = () => {
    setCurrentMonth((prev) => prev.clone().subtract(1, "month"));
  };

  const handleNextMonth = () => {
    setCurrentMonth((prev) => prev.clone().add(1, "month"));
  };

  const navBtnStyle = {
    border: "none",
    background: "#f4f6f8",
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    cursor: "pointer",
    fontSize: "18px",
    fontWeight: "bold",
  };

  return (
    <div style={{ display: "" }}>
      <div style={{ width: "100%" }}>
       <div className="dashboard-header">
  <span className="dashboard-title">
    Daily Task Count
  </span>

  <div className="month-wrapper">
    <div className="month-switcher">
      <button onClick={handlePrevMonth} style={navBtnStyle}>
        &#8249;
      </button>

      <span className="month-text">
        {currentMonth.format("MMMM YYYY")}
      </span>

      <button
        onClick={handleNextMonth}
        disabled={currentMonth.isSame(moment(), "month")}
        style={navBtnStyle}
      >
        &#8250;
      </button>
    </div>
  </div>
</div>
        {isLoading ? <div style={{minHeight:"700px", display:'flex', justifyContent:'center', alignItems:'center'}}>
          <Loader /></div> : <canvas ref={taskChartRef}></canvas>}
      </div>
    </div>
  );
};

export default ChartComponent;
